import React from 'react';
import { View, StyleSheet, Text, TouchableOpacity } from 'react-native';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

class DietaryOptionsDropdown extends React.Component {
    render() {
        const { changePreference, currentlySelected, options } = this.props;
        return (
            <View style={styles.dropdownContainer}>
                {options.map((singleValue) => {
                    const isSelected = currentlySelected && singleValue.display === currentlySelected.display;
                    return (<TouchableOpacity
                        style={isSelected ? styles.selectedOptionContainer : styles.optionContainer}
                        onPress={() => changePreference(singleValue)}
                    >
                        <Text style={isSelected ? [styles.option, { fontFamily: Theme.Custom700 }] : styles.option}>
                            {singleValue.display}
                        </Text>
                    </TouchableOpacity>)
                }
                )}
            </View>
        );
    }
}

const styles = StyleSheet.create({
    dropdownContainer: {
        width: '100%',
        padding: defaultScale(5),
        paddingTop: 0,
    },
    optionContainer: {
        backgroundColor: Theme.GREY_LIGHT,
        borderBottomWidth: defaultScale(1),
        borderColor: Theme.GREY_MEDIUM_LIGHT
    },
    option: {
        ...Theme.textStyle.small,
        color: Theme.GREY_DARK,
        padding: defaultScale(5),
    },
    selectedOptionContainer: {
        backgroundColor: Theme.GREY_MEDIUM_LIGHT,
        borderBottomWidth: defaultScale(1),
        borderColor: Theme.GREY_MEDIUM_LIGHT
    }
});

export default DietaryOptionsDropdown;
